import React, { useState, useEffect } from 'react'
import { IconButton, TextField, Divider, debounce } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { GridColDef, GridPaginationModel, GridRowParams, ptBR } from '@mui/x-data-grid'
import { Header, Content, Image, StyledDataGrid } from './styles'
import Cliente from '../../../interfaces/cliente'
import ClienteDialog from '../../components/ClienteDialog'
import Surfguy from '../../../assets/surfguy.png'
import { EsconderPorNivelAcesso, getUser } from '../../../services/auth'
import { NivelAcessoEnum } from '../../../utils/enum/nivelAcessoEnum'
import pagedGet from '../../../services/pagedGet'
import { DEFAULT_PAGE_SIZE } from '../../../interfaces/pagedResult'

const colunas: GridColDef[] = [
  {
    field: 'nome',
    headerName: 'Nome',
    flex: 1
  },
  {
    field: 'telefone',
    headerName: 'Telefone',
    flex: 1
  },
  {
    field: 'cpf',
    headerName: 'CPF',
    flex: 1
  }
]

const Clientes: React.FC = () => {
  const [pesquisa, setPesquisa] = useState<string>('')
  const [dialogAberto, setDialogAberto] = useState<boolean>(false)
  const [clientes, setClientes] = useState<Cliente[]>([])
  const [clienteSelecionado, setClienteSelecionado] = useState<Cliente | null>(null)
  const [pesquisarTrigger, setPesquisarTrigger] = useState<boolean>(false);
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  })
  const [rowCount, setRowCount] = useState(0)

  const user = getUser();

  const pesquisar = debounce((event: React.ChangeEvent<HTMLInputElement>) => {
    setPesquisa(event.target.value);
    setPaginationModel(prev => ({ ...prev, page: 0 }))
  }, 500)

  useEffect(() => {
    if (dialogAberto)
      return

    const buscarDados = async () => {
      const result = await pagedGet<Cliente>('/cliente', {
        page: paginationModel.page + 1,
        pageSize: paginationModel.pageSize,
        pesquisa: pesquisa || undefined,
      })
      setClientes(result.items)
      setRowCount(result.totalCount)
    }

    buscarDados()
  }, [pesquisa, pesquisarTrigger, dialogAberto, paginationModel])

  const handleAdicionar = () => {
    setClienteSelecionado(null)
    setDialogAberto(!dialogAberto)
  }

  const handleClickLinha = (params: GridRowParams) => {
    setClienteSelecionado(params.row as Cliente)
    setDialogAberto(true)
  }

  return (
    <>
      <Image src={Surfguy} />
      <Header>
        <TextField
          id="pesquisa"
          label="Pesquisar"
          onChange={pesquisar}
          type="search"
          fullWidth
          autoFocus
          autoComplete='off'
          inputProps={{ style: { textTransform: "uppercase" } }}
        />
        <IconButton
          color="primary"
          onClick={_ => setPesquisarTrigger(!pesquisarTrigger)}
        >
          <SearchIcon />
        </IconButton>
        <EsconderPorNivelAcesso nivelAcesso={[NivelAcessoEnum.admin, NivelAcessoEnum.gerente, NivelAcessoEnum.usuario]}>
          <>
            <Divider orientation="vertical" variant="middle" flexItem />
            <IconButton
              onClick={handleAdicionar}
              color="primary"
            >
              <AddCircleIcon />
            </IconButton>
          </>
        </EsconderPorNivelAcesso>
      </Header>
      <Content>
        <StyledDataGrid
          localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          columns={colunas}
          rows={clientes}
          disableColumnMenu={true}
          hideFooterSelectedRowCount={true}
          onRowClick={handleClickLinha}
          pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          rowCount={rowCount}
          pageSizeOptions={[20, 50, 100]}
          sx={{
            textTransform: 'uppercase'
          }}
        />
      </Content>
      {dialogAberto ? <ClienteDialog aberto={dialogAberto} setAberto={setDialogAberto} entidade={clienteSelecionado} /> : <></>}
    </>
  )
}

export default Clientes
